import createAsyncGetters from '../config/asyncGetters/createAsyncGetters';
import { createReportableError } from '../utils/errors';

export const socialAsyncGetters = createAsyncGetters({
  /**
   * Get the short link for the given URL
   */
  getShortLink: async (args: { url: string; data?: object }, api) => {
    const { url, data = {} } = args;

    const res = await api.fetch({
      method: 'POST',
      url: 'https://playco.click',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amplitudeId: process.env.AMPLITUDE,
        userId: api.getUserID(),
        url,
        ...data,
      }),
      retry: {
        times: 3,
      },
    });

    const { statusCode, body } = res;

    if (statusCode !== 200) {
      api.reportError(
        createReportableError(
          'error',
          new Error('Failed to generate short link' + body),
        ),
      );
      return { shortLink: url, linkId: null }; // Fallback to original URL
    }

    try {
      const result = JSON.parse(body) as { linkId?: string } | undefined;
      const linkId = result?.linkId as string | undefined;
      if (!linkId) {
        return { shortLink: url, linkId: null }; // Fallback to original URL
      }

      return { shortLink: `https://playco.click/${linkId}`, linkId };
    } catch (error: any) {
      api.reportError(createReportableError('error', error));
      return { shortLink: url, linkId: null }; // Fallback to original URL
    }
  },
});
